module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightbulb-fill-369824e8.svg";